var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardDemandMaterialSelectDrawer" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.form, size: "small", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物料编码", prop: "material_id" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.form.material_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "material_id", $$v)
                  },
                  expression: "form.material_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料名称", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料类型", prop: "material_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    placeholder: "请选择",
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.material_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "material_type", $$v)
                    },
                    expression: "form.material_type",
                  },
                },
                _vm._l(_vm.materialTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "印刷类型", prop: "print_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.print_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "print_type", $$v)
                    },
                    expression: "form.print_type",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "标准版" } }),
                  _c("el-option", { attrs: { value: "2", label: "个性化" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "业务类型", prop: "card_bin_group_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  on: { change: _vm.changeCardBinId },
                  model: {
                    value: _vm.form.card_bin_group_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "card_bin_group_id", $$v)
                    },
                    expression: "form.card_bin_group_id",
                  },
                },
                _vm._l(_vm.cardTypeChannelList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "卡类型", prop: "card_type_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.card_type_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "card_type_id", $$v)
                    },
                    expression: "form.card_type_id",
                  },
                },
                _vm._l(_vm.cardTypeList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "版面", prop: "layout_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    placeholder: "请选择",
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.layout_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "layout_id", $$v)
                    },
                    expression: "form.layout_id",
                  },
                },
                _vm._l(_vm.layoutList, function (item) {
                  return _c("el-option", {
                    key: item.layout_id,
                    attrs: { label: item.name, value: item.layout_id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "仓库", prop: "branch_office_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    placeholder: "请选择",
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.branch_office_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "branch_office_id", $$v)
                    },
                    expression: "form.branch_office_id",
                  },
                },
                _vm._l(_vm.branchCompanyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: item.id, label: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库存大于0", prop: "have_stock_count" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.have_stock_count,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "have_stock_count", $$v)
                    },
                    expression: "form.have_stock_count",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "是" } }),
                  _c("el-option", { attrs: { value: "0", label: "否" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.search },
                },
                [_vm._v("搜索")]
              ),
              _c("el-button", { on: { click: _vm.reset } }, [_vm._v("重置")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "table",
          staticStyle: { width: "100%", margin: "10px 20px" },
          attrs: {
            border: "",
            "header-cell-style": { background: "#F1F1F1", color: "#333333" },
            data: _vm.dataList,
            "tooltip-effect": "dark",
          },
          on: {
            "sort-change": _vm.sortChange,
            "selection-change": _vm.handleSelectionChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料编码",
              prop: "material_id",
              align: "left",
              sortable: "sort_order",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料预览图",
              width: "120px",
              prop: "pre_img",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.pre_img
                      ? _c("el-image", {
                          staticStyle: { height: "50px", width: "70px" },
                          attrs: {
                            src: scope.row.pre_img,
                            "preview-src-list": [scope.row.pre_img],
                            fit: "contain",
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "物料名称", prop: "name", align: "left" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料类型",
              prop: "material_type_des",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "业务类型/版面", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          (scope.row.card_bin_group_des || "-") +
                            " / " +
                            (scope.row.layout_des || "-")
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "卡类型", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.card_type_des || "-") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "印刷类型", prop: "print_type_des", align: "left" },
          }),
          _c("el-table-column", {
            attrs: { label: "仓库", prop: "branch_office_name", align: "left" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "库存",
              width: "90px",
              prop: "stock_count",
              align: "left",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "20px 0 100px 0" } },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "page-size": _vm.form.pagesize,
              "page-sizes": [20, 50, 100, 200],
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.page,
            },
            on: {
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                disabled: !_vm.selection.length,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确 定（已选 " + _vm._s(_vm.selection.length) + "）")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }